import { api } from '@/api/client';
import type { components } from '@/api/schema';

export type EventoSeguridad = components['schemas']['SecurityEvent']['type'];

/** Reporte silencioso (plan §12.1, capa 3): si falla, no interrumpe al alumno. */
export function reportarEvento(type: EventoSeguridad, contentType?: string, contentId?: string) {
  void api
    .POST('/api/v1/me/security-events', {
      body: { type, ...(contentType ? { contentType } : {}), ...(contentId ? { contentId } : {}) },
    })
    .catch(() => undefined);
}
